export default __webpack_public_path__ + "static/media/33.3b7971cf.jpg";